/**
 * 创建群组相关服务
 * Bai.Zhiming
 * 2019-7-23
 */
angular.module("createGroupServiceModule", [
    'imGroupInfoModule'
]).
factory("createGroupService", ['$modal', '$q', function($modal, $q) {
    return {
        /**
         * [groupInfo description] 群组命名
         * @param  {[type]} name [description] 名称
         * @return {[type]}      [description]
         */
        groupInfo(name, groupImage, Introduction, Notification) {
            let deffer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./IM/chatWindow/chatDirectory/groupDirectory/createGroup/service/groupInfo/groupInfo_tpl.html",
                windowClass: 'im_group_info',
                backdrop: false,
                keybord: false,
                controller: "imGroupInfoCtrl",
                resolve: {
                    groupInfo: function() {
                        return {
                            name: name,
                            groupImage: groupImage,
                            Introduction: Introduction,
                            Notification: Notification
                        };
                    }
                }
            });
            modalInstance.result.then(function(name) {
                deffer.resolve(name);
            }, function() {
                deffer.reject();
            });
            return deffer.promise;
        }
    };
}]);